var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2983 11.14L11.4567 10.9678C12.3756 9.96911 12.8943 8.66573 12.8943 7.28065C12.8943 4.27227 10.4555 1.8335 7.44716 1.8335C4.43877 1.8335 2 4.27227 2 7.28065C2 10.289 4.43877 12.7278 7.44716 12.7278C8.44639 12.7278 9.40557 12.4586 10.2437 11.9562L10.4069 11.8583L13.5488 15.0001C13.7711 15.2224 14.1314 15.2224 14.3536 15.0001C14.5759 14.7779 14.5759 14.4176 14.3536 14.1953L11.2983 11.14ZM7.44716 11.5896C5.06739 11.5896 3.13821 9.66041 3.13821 7.28065C3.13821 4.90089 5.06739 2.97171 7.44716 2.97171C9.82692 2.97171 11.7561 4.90089 11.7561 7.28065C11.7561 9.66041 9.82692 11.5896 7.44716 11.5896Z",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.ef3eb016ca873abd818055f134fcf114.svg";
export { ForwardRef as ReactComponent };